module.exports = __webpack_public_path__ + "logo_brilla002.png";